/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q9Inputs */

const en_home_faq_q9 = /** @type {(inputs: Home_Faq_Q9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What programming language is CADCraft written in?`)
};

/**
* | output |
* | --- |
* | "What programming language is CADCraft written in?" |
*
* @param {Home_Faq_Q9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_faq_q9 = /** @type {((inputs?: Home_Faq_Q9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_faq_q9(inputs)
});
export { home_faq_q9 as "home.faq.q9" }